import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './WithdrawalManagement.css';

function WithdrawalManagement() {
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [statusFilter, setStatusFilter] = useState('pending');

  useEffect(() => {
    fetchWithdrawals();
  }, [currentPage, statusFilter]);

  const fetchWithdrawals = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`https://trcsite.net/api/admin/withdrawals?page=${currentPage}&limit=20&status=${statusFilter}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      setWithdrawals(response.data.withdrawals);
      setTotalPages(response.data.totalPages);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching withdrawals:', error);
      setLoading(false);
    }
  };

  const approveWithdrawal = async (withdrawalId) => {
    const txHash = prompt('Please enter transaction hash:');
    if (!txHash) return;

    try {
      const token = localStorage.getItem('token');
      await axios.post(`https://trcsite.net/api/admin/withdrawals/${withdrawalId}/approve`, 
        { tx_hash: txHash },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      fetchWithdrawals(); // Refresh the list
      alert('Withdrawal approved successfully');
    } catch (error) {
      console.error('Error approving withdrawal:', error);
      alert('Failed to approve withdrawal');
    }
  };

  const rejectWithdrawal = async (withdrawalId) => {
    const reason = prompt('Please enter rejection reason:');
    if (!reason) return;

    try {
      const token = localStorage.getItem('token');
      await axios.post(`https://trcsite.net/api/admin/withdrawals/${withdrawalId}/reject`, 
        { reason },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      fetchWithdrawals(); // Refresh the list
      alert('Withdrawal rejected successfully');
    } catch (error) {
      console.error('Error rejecting withdrawal:', error);
      alert('Failed to reject withdrawal');
    }
  };

  if (loading) {
    return <div className="loading">Loading withdrawals...</div>;
  }

  return (
    <div className="management-section">
      <div className="section-header">
        <h2>Withdrawal Management</h2>
        <div className="filters">
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            style={{
              padding: '8px 12px',
              border: '1px solid #344258',
              borderRadius: '4px',
              backgroundColor: '#1a2332',
              color: '#ffffff'
            }}
          >
            <option value="pending">Pending</option>
            <option value="completed">Completed</option>
            <option value="rejected">Rejected</option>
            <option value="">All</option>
          </select>
        </div>
      </div>

      <div className="table-container">
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid #344258' }}>
              <th style={{ padding: '12px', textAlign: 'left', color: '#b0b8c4' }}>User</th>
              <th style={{ padding: '12px', textAlign: 'left', color: '#b0b8c4' }}>Currency</th>
              <th style={{ padding: '12px', textAlign: 'left', color: '#b0b8c4' }}>Amount</th>
              <th style={{ padding: '12px', textAlign: 'left', color: '#b0b8c4' }}>Fee</th>
              <th style={{ padding: '12px', textAlign: 'left', color: '#b0b8c4' }}>To Address</th>
              <th style={{ padding: '12px', textAlign: 'left', color: '#b0b8c4' }}>TX Hash</th>
              <th style={{ padding: '12px', textAlign: 'left', color: '#b0b8c4' }}>Status</th>
              <th style={{ padding: '12px', textAlign: 'left', color: '#b0b8c4' }}>Created</th>
              <th style={{ padding: '12px', textAlign: 'left', color: '#b0b8c4' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {withdrawals.map((withdrawal) => (
              <tr key={withdrawal.id} style={{ borderBottom: '1px solid #2a3b52' }}>
                <td style={{ padding: '12px' }}>
                  <div>
                    <div style={{ fontWeight: 'bold' }}>{withdrawal.user_name}</div>
                    <div style={{ fontSize: '12px', color: '#b0b8c4' }}>{withdrawal.user_email}</div>
                  </div>
                </td>
                <td style={{ padding: '12px', fontWeight: 'bold' }}>{withdrawal.currency}</td>
                <td style={{ padding: '12px' }}>{withdrawal.amount}</td>
                <td style={{ padding: '12px' }}>{withdrawal.fee || '0'}</td>
                <td style={{ padding: '12px', fontFamily: 'monospace', fontSize: '12px' }}>
                  {withdrawal.to_address}
                </td>
                <td style={{ padding: '12px', fontFamily: 'monospace', fontSize: '12px' }}>
                  {withdrawal.tx_hash || 'N/A'}
                </td>
                <td style={{ padding: '12px' }}>
                  <span style={{
                    color: withdrawal.status === 'completed' ? '#00c853' : 
                           withdrawal.status === 'pending' ? '#ffa726' : '#ff1744',
                    fontWeight: 'bold'
                  }}>
                    {withdrawal.status.toUpperCase()}
                  </span>
                </td>
                <td style={{ padding: '12px' }}>
                  {new Date(withdrawal.created_at).toLocaleDateString()}
                </td>
                <td style={{ padding: '12px' }}>
                  {withdrawal.status === 'pending' && (
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <button
                        onClick={() => approveWithdrawal(withdrawal.id)}
                        style={{
                          padding: '6px 12px',
                          backgroundColor: '#00c853',
                          color: 'white',
                          border: 'none',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          fontSize: '12px'
                        }}
                      >
                        Approve
                      </button>
                      <button
                        onClick={() => rejectWithdrawal(withdrawal.id)}
                        style={{
                          padding: '6px 12px',
                          backgroundColor: '#ff1744',
                          color: 'white',
                          border: 'none',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          fontSize: '12px'
                        }}
                      >
                        Reject
                      </button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="pagination" style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
          <button
            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
            style={{
              padding: '8px 16px',
              border: '1px solid #344258',
              backgroundColor: currentPage === 1 ? '#2a3b52' : '#2962ff',
              color: '#ffffff',
              cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
              borderRadius: '4px'
            }}
          >
            Previous
          </button>
          
          <span style={{ color: '#b0b8c4', padding: '8px 16px', alignSelf: 'center' }}>
            Page {currentPage} of {totalPages}
          </span>
          
          <button
            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
            disabled={currentPage === totalPages}
            style={{
              padding: '8px 16px',
              border: '1px solid #344258',
              backgroundColor: currentPage === totalPages ? '#2a3b52' : '#2962ff',
              color: '#ffffff',
              cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
              borderRadius: '4px'
            }}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}

export default WithdrawalManagement;